"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13 12h4c0-2.5-2-5.0048-5-5-2.5975.0041-4.4453 1.8753-4.8944 4h.0334C8.0386 7.9933 13 8.3626 13 12z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9316 22c0-4.4183-3.5817-8-8-8v-2c5.5229 0 10 4.4772 10 10h-2z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9316 22c0-2.2091-1.7908-4-4-4v-2c3.3138 0 6 2.6863 6 6h-2z"
  }), _react.default.createElement("path", {
    d: "M3.8445 21.9509c-.5363.5363-1.4059.5363-1.9422 0-.5364-.5363-.5364-1.4059 0-1.9423.5363-.5363 1.4059-.5363 1.9422 0 .5364.5364.5364 1.406 0 1.9423zM5.2899 10C6.1504 7.1085 8.8289 5 12 5c3.866 0 7 3.134 7 7 0 3.3511-2.3548 6.1522-5.5 6.8389v2.0367C17.7566 20.1614 21 16.4595 21 12c0-4.9706-4.0294-9-9-9-4.2832 0-7.8675 2.992-8.777 7H5.29z"
  })];
};

exports.default = _default;